export interface IPProduct {
  brandName: string;
  actualPrice: string;
  ippFlag: boolean; // all product list needs to display with IPP flag true
  name: string;
  quantity: number;
  image: string;
  categories?: string[]; // need for BE
  desc?: string;
  discountedPrice?: number;
  productId?: string;
  isPromotionalProduct?: boolean;
}

export enum orderType {
  Normal = 'NORMAL',
  Gco = 'GCO',
  Go = 'GO',
  Registration = 'REGISTRATION',
  Renewal = 'RENEWAL',
  Proxy = 'PROXY',
  Group = 'GROUP',
}

export enum paymentNavigation {
  Saved_Card = 'SAVED_CARD',
  Bank_Account = 'BANK_ACCOUNT',
  Ampurse = 'AMPURSE',
  Ampoints = 'AMPOINTS',
  Credit_Voucher = 'CREDIT_VOUCHER',
}

export enum instalmentOrderType {
  ORDER = 'ORDER',
  SUBSCRIPTION = 'SUBSCRIPTION',
}
